"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.debug = exports.debuggers = void 0;
const debug_1 = __importDefault(require("debug"));
const hooks_1 = require("../hooks");
exports.debuggers = {};
exports.debug = {
    namespace: "reactify-search",
    log: (namespace, formatter, ...args) => {
        if (!exports.debuggers[namespace]) {
            exports.debuggers[namespace] = (0, debug_1.default)(`${exports.debug.namespace}:${namespace}`);
        }
        exports.debuggers[namespace](formatter, ...args);
    },
    hook: hooks_1.useDebugger,
    hookOnce: hooks_1.useDebuggerOnce
};
//# sourceMappingURL=debug.js.map